import * as React from 'react';

import FileSheets32 from './FileSheets32';

export const fileSheets32 = () => <FileSheets32 />;

export default {
    title: 'Icon/Content/FileSheets32',
    component: FileSheets32,
    parameters: {
        notes: "`import FileSheets32 from 'box-ui-elements/es/icon/content/FileSheets32';`",
    },
};
